import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function CrearMarca({
  onClose = () => {},
  onCreated = () => {},
}) {
  const [descricao, setDescricao] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = descricao.trim() !== "";

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const guardar = async () => {
    if (!isValid || saving) return;

    setSaving(true);
    setError("");

    try {
      const payload = { descricao: descricao.trim() };
      const created = await appFetchJson(apiRoutes.marcas.create, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      onCreated(created);
      onClose();
    } catch (e) {
      console.error("Error creando marca:", e);
      setError(e?.message || "Ocurrió un error al guardar la marca.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Marca</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">
            Introduzca la descripción de la nueva marca
          </p>

          {error && (
            <div className="text-red-600 mb-3 font-medium">{error}</div>
          )}

          <div className="form-grid">
            <div className="form-row">
              <label className="form-label">Descripción *</label>
              <input
                type="text"
                className="input"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                placeholder="Descripción de la marca"
              />
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label="Guardar"
              isValid={isValid}
              saving={saving}
              onClick={guardar}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}